import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Input, Badge, Button } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/cp3kService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";

class TableComponent extends Component {
  dataTableBloc = new DataTableBloc();
  queryParams = new URLSearchParams(window.location.search);

  source;
  historyTable = "P3KTableSecondaryActive";
  defaultOrder = "cp3k_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      uploadSkUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      col1: true,
      col2: false,
      dataSelected: [],
      checkAll: false,
      periodUuid: this.queryParams.get("uuid"),
      roleId: localStorage.getItem("currentRoleId"),
    };
  }

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseId = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).locale("id-id").format("DD MMMM YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      p3k_status: 1,
      period_uuid: this.state.periodUuid,
      roleId: this.state.roleId,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };
  handleDownloadDraftSK = (uuid) => {
    this.dataTableBloc.fetchDownloadDraftSK({
      cp3k_uuid: uuid,
    });
  };
  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    console.log(uuid, checked);
  };

  handleButtonProcess = () => {
    console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan memproses data terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].cp3k_id;
      let thisUuid = this.state.rows[i].cp3k_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          //this.activeData()
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].cp3k_id;
            this.setState({
              [`check${thisId}`]: false,
            });
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          //this.props.totalCandidate(response.total)
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.downloadDraftSKChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.dataTableBloc.downloadDraftSKChannel?.unsubscribe();
  }

  columns = [
    {
      key: "cp3k_bkn_confirmation_number",
      text: "",
      className: "cp3k_bkn_confirmation_number",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Penetapan NIP BKN <br />
            Nomor <br />
            Tanggal
          </div>
        );
      },
      cell: (record) => {
        return (
          <div>
            {record.cp3k_bkn_confirmation_number}
            <br />
            {this.dateParseId(record.cp3k_bkn_confirmation_date)}
          </div>
        );
      },
    },
    {
      key: "cp3k_candidate_full_name",
      text: "",
      className: "cp3k_candidate_full_name",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Nama <br />
            NIP <br />
            Tempat, Tanggal Lahir
          </div>
        );
      },
      cell: (record) => {
        return (
          <div>
            {record.cp3k_candidate_full_name}
            <br />
            {`${record.cp3k_candidate_nip}`}
            <br />
            {`${
              record.cp3k_candidate_place_of_birth_city_name != null
                ? record.cp3k_candidate_place_of_birth_city_name
                : record.cp3k_candidate_place_of_birth_city_text
            }, ${this.dateParseId(record.cp3k_candidate_date_of_birth)}`}
          </div>
        );
      },
    },
    {
      key: "cp3k_candidate_gender_name",
      text: "Jenis Kelamin",
      className: "cp3k_candidate_gender_name",
      sortable: true,
    },
    {
      key: "cp3k_candidate_last_education_name",
      text: "Pendidikan Tertinggi",
      className: "cp3k_candidate_last_education_name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="text-center">
            {record.cp3k_candidate_last_education_name}
            <br />
            {record.cp3k_candidate_last_education_major}
          </div>
        );
      },
    },
    {
      key: "cp3k_candidate_rank_name",
      text: "Golongan",
      className: "cp3k_candidate_rank_name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="text-center">
            {`${record.cp3k_candidate_rank_name}`}
          </div>
        );
      },
    },
    {
      key: "jabatan_pada_unit_kerja",
      text: "",
      className: "jabatan_pada_unit_kerja",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Jabatan Pada <br />
            Unit Kerja
          </div>
        );
      },
    },
    {
      key: "cp3k_p3k_status_name",
      text: "Status",
      className: "cp3k_p3k_status_name",
      sortable: true,
      width: "100",
      cell: (record) => {
        return (
          <label
            className={`badge rounded-pill ${record.cp3k_p3k_status_class} font-size-12`}
          >
            {record.cp3k_p3k_status_name}
          </label>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.cp3k_id;
        var status = record.cp3k_p3k_status;
        var submit = record.cp3k_p3k_status_submit;
        return (
          <Fragment>
            {/* {submit == 1 || submit == 2 ? ( */}
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.cp3k_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-search-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detail P3K
              </Tooltip>
            </span>
            {/* ) : (
              ""
            )} */}
            {status == 0 && submit == 0 && this.state.roleId == 2 ? (
              <span>
                <button
                  className="btn btn-info btn-sm"
                  id={"draftSk-" + thisId}
                  onClick={() => {
                    this.handleDownloadDraftSK(record.cp3k_uuid);
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-file-download-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["draftSk" + thisId]}
                  target={"draftSk-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["draftSk" + thisId]: !this.state["draftSk" + thisId],
                    });
                  }}
                >
                  Download Draft SK
                </Tooltip>

                <button
                  className="btn btn-warning btn-sm"
                  id={"uploadSk-" + thisId}
                  onClick={() => {
                    this.setState({
                      uploadSkUuid: record.cp3k_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-file-upload-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["uploadSk" + thisId]}
                  target={"uploadSk-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["uploadSk" + thisId]: !this.state["uploadSk" + thisId],
                    });
                  }}
                >
                  Upload Dokumen
                  {/* File PRAJAB & MCU */}
                </Tooltip>
              </span>
            ) : (
              ""
            )}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/dokumen_pengangkatan_pppk.html?detail&uuid=" +
              this.state.detailUuid +
              "&period_uuid=" +
              this.state.periodUuid
            }
          />
        ) : null}
        {this.state.uploadSkUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/dokumen_pengangkatan_pppk.html?upload&uuid=" +
              this.state.uploadSkUuid +
              "&period_uuid=" +
              this.state.periodUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableComponent;
